import TableSelectedItem from "./TableSelectedItem";
export default TableSelectedItem;
